document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('[data-franchise-form]');
  if (!section || section.dataset.franchiseFormInitialized) return;
  section.dataset.franchiseFormInitialized = 'true';

  const phoneInput = section.querySelector('[data-franchise-phone]');

  if (phoneInput) {
    phoneInput.addEventListener('input', () => {
      phoneInput.value = phoneInput.value.replace(/\D/g, '').slice(0, 10);
    });
  }

  const flashMessages = section.querySelectorAll('.franchise-form__success, .franchise-form__error');
  for (const msg of flashMessages) {
    setTimeout(() => {
      msg.remove();
    }, 5000);
  }

  const scrollTargets = document.querySelectorAll('[data-franchise-scroll-to-form]');
  for (const target of scrollTargets) {
    target.addEventListener('click', (e) => {
      e.preventDefault();
      section.scrollIntoView({ behavior: 'smooth' });
    });
  }
});
